import { PreferenceEditorComponentController } from "./preference-editor.controller";
/**
 * @todo move to Component ver
 */
export class PreferenceEditorComponent implements angular.IComponentOptions {
    public readonly bindings: { [boundProperty: string]: string }  = {
        modalInstance: "<modalInstance", 
        resolve: "<resolve",
    }
    public templateUrl: string = "preference-editor.tpl";
    public controller: angular.Injectable<angular.IControllerConstructor> =  PreferenceEditorComponentController;
    public controllerAs: string = "$ctrl";
};